<template>
  <transition name="slide-fade">
    <mobile-menu v-if="isMenuOpen" @menu="toggleMenu" class="fixed lg:hidden" />
  </transition>
  <Header @menu="toggleMenu" ref="header" />
  <div
    ref="container"
    style="
      min-height: calc(100vh - 120px);
      transition: min-height 0.5s ease-in-out;
    "
  >
    <slot />
  </div>
  <Footer ref="footer" />
</template>

<script setup>
const header = ref(null);
const footer = ref(null);
const container = ref(null);

const isMenuOpen = ref(false);

function toggleMenu(v) {
  isMenuOpen.value = v;
}
onMounted(async () => {
  await nextTick();
  const height = header.value.$el.clientHeight + footer.value.$el.clientHeight;
  container.value.style.minHeight = "calc(100vh - " + height + "px)";
});
</script>
